module.exports = __webpack_public_path__ + "static/media/25ton-variant-2.fcf5ae12.jpg";